/**
 * This function contains code that was transferred from the "fe-billing-web/src/apis/helpers.js"
 */
import axios from 'axios'
import ResponseInterceptor from './response-interceptor'

axios.interceptors.response.use(ResponseInterceptor)

const commonParams = {}

const CancelToken = axios.CancelToken
const _cancel = {}
const rbracket = /\[\]$/

export function setCommonParams(obj) {
  Object.assign(commonParams, obj)
}

function handleAjax(ajaxPromise, options = {}) {
  const { returnAllData = false, url = '' } = options

  return ajaxPromise
    .then((response) => {
      if (returnAllData) {
        return response
      }

      const serverData = response?.data
      if (!serverData) {
        return Promise.reject(new Error('Unexpected response format. Response body should contain data attribute.'))
      }
      if (!Object.prototype.hasOwnProperty.call(serverData, 'result')) {
        return serverData
      }
      if (serverData.errorCode === 0) {
        return serverData.result
      } else if (typeof serverData.errorCode === 'undefined') {
        return serverData
      } else {
        return handleError(serverData)
      }
    })
    .catch((e) => {
      return Promise.reject(axios.isCancel(e) ? e.message : e)
    })
}
export function get(url) {
  return function (params = {}) {
    return handleAjax(
      axios.get(url, {
        params: Object.assign({}, commonParams, params),
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        })
      }),
      { url }
    )
  }
}
export function postBlob(url, returnAllData = false) {
  return function (params = {}) {
    return handleAjax(
      axios.post(url, param(Object.assign({}, commonParams, params)), {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'xmlhttprequest'
        },
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        })
      }),
      { url, returnAllData }
    )
  }
}
export function post(url, returnAllData = false) {
  return function (params = {}) {
    return handleAjax(
      axios.post(url, param(Object.assign({}, commonParams, params)), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'xmlhttprequest'
        },
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        })
      }),
      { url, returnAllData }
    )
  }
}
export function postJson(url, returnAllData = false) {
  return function ({ data, params } = { data: null, params: null }) {
    return handleAjax(
      axios.post(url, data, {
        params,
        headers: {
          'Content-Type': 'application/json'
        },
        cancelToken: new CancelToken(function executor(c) {
          _cancel[url] = c
        })
      }),
      { url, returnAllData }
    )
  }
}
export function cancel(url) {
  return function () {
    _cancel[url] && _cancel[url]()
  }
}
function handleError(serverData) {
  if (serverData.errorCode === 201) {
    //User Log Out
    window.location = '/signin'
  } else {
    return Promise.reject(new Error(serverData.errorMessage))
  }
}
function param(obj) {
  if (!obj) {
    return ''
  }
  const s = []
  for (const prefix in obj) {
    buildParams(prefix, obj[prefix], add)
  }

  function add(key, value) {
    s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value)
  }

  return s.join('&')
}
function buildParams(prefix, obj, add) {
  if (Array.isArray(obj)) {
    // Serialize array item.
    obj.forEach(function (v, i) {
      if (rbracket.test(prefix)) {
        // Treat each array item as a scalar.
        add(prefix, v)
      } else {
        // Item is non-scalar (array or object), encode its numeric index.
        buildParams(prefix + '[' + (typeof v === 'object' && v !== null ? i : '') + ']', v, add)
      }
    })
  } else if (typeof obj === 'object') {
    // Serialize object item.
    for (const name in obj) {
      buildParams(prefix + '[' + name + ']', obj[name], add)
    }
  } else {
    // Serialize scalar item.
    add(prefix, obj)
  }
}
